import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';

export type TemplatesMenuEmptyStateVariant = 'categoryVacuum' | 'generic';

export type TemplatesMenuEmptyStateProps = {
  variant: TemplatesMenuEmptyStateVariant;
  /** שם קטגוריה להחלפה ב־`descriptionCategory` — `{CategoryName}` */
  categoryDisplayName: string;
  genericMessage: string;
  titleCategory: string;
  descriptionCategory: string;
  ctaCategory: string;
};

function interpolateCategoryDescription(template: string, categoryDisplayName: string): string {
  return template.replace(/\{CategoryName\}/g, categoryDisplayName);
}

const TemplatesMenuEmptyState: React.FC<TemplatesMenuEmptyStateProps> = ({
  variant,
  categoryDisplayName,
  genericMessage,
  titleCategory,
  descriptionCategory,
  ctaCategory,
}) => {
  const isCategoryVacuum = variant === 'categoryVacuum';

  return (
    <Stack
      role="status"
      aria-live="polite"
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{
        px: 2,
        py: 3,
        textAlign: 'center',
        maxWidth: 400,
        mx: 'auto',
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'action.hover',
          color: 'text.secondary',
        }}
      >
        {isCategoryVacuum ? (
          <CategoryOutlinedIcon sx={{ fontSize: 28 }} aria-hidden />
        ) : (
          <SearchOffOutlinedIcon sx={{ fontSize: 28 }} aria-hidden />
        )}
      </Box>

      {isCategoryVacuum ? (
        <>
          <Typography variant="subtitle1" color="text.primary" sx={{ fontWeight: 600 }}>
            {titleCategory}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {interpolateCategoryDescription(descriptionCategory, categoryDisplayName)}
          </Typography>
          <Typography variant="caption" color="text.disabled" sx={{ display: 'block', maxWidth: 320 }}>
            {ctaCategory}
          </Typography>
        </>
      ) : (
        <Typography variant="body1" color="text.secondary">
          {genericMessage}
        </Typography>
      )}
    </Stack>
  );
};

export default React.memo(TemplatesMenuEmptyState);
